

// src/config/api.js
export const FOOD_API = process.env.REACT_APP_FOOD_API;
export const MAIN_FOOD_API = process.env.REACT_APP_MAIN_FOOD_API;
export const SUBSCRIPTION_API = process.env.REACT_APP_SUBSCRIPTION_API;
export const MAIN_SUBSCRIPTION_API = process.env.REACT_APP_MAIN_SUBSCRIPTION_API;
export const WS_URL = process.env.REACT_APP_WS_URL;
export const PHONEPAY_URL = process.env.REACT_APP_PHONEPAY_URL;
export const MAIN_API = process.env.REACT_APP_MAIN_URL;
export const CATERING_API = process.env.REACT_APP_CATERINGS_API;
export const BASE_URL = process.env.REACT_APP_API_URL;

// Razorpay Keys
export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
// Google Maps
export const GOOGLE_MAPS_API_KEY = "AIzaSyD_peZch6hJtq-3wEE4-4z3r68o7Y7nw3c";